<script lang="ts">
  import NavBar from "./components/nav/NavBar.svelte";
  import Footer from "./components/Footer.svelte";
  import { currentPage } from "./store/routes";
  import Modal from "svelte-simple-modal";
  
  export let name: string;
</script>

<Modal>
  <NavBar />
  <!-- <Home /> -->
  <!-- <Gallery /> -->
  <!-- <Market /> -->
  <!-- <About /> -->
  <!-- <NftInfo /> -->
  <!-- <NftMint /> -->
  <svelte:component this={$currentPage} />
  <Footer />
</Modal>

<style>
</style>
